import BaseClass from "../BaseClass";

export class ClipboardButton extends BaseClass {
    constructor(element) {
        super(element);

        this.init();
    }

    init() {
        this.initListeners();
    }

    initListeners() {
        this.$element.on('click', $.proxy(this.onClick, this));
    }

    onClick() {
        let value;

        const input = this.$element.data('input');
        if (typeof input != 'undefined') {
            const $input = $(input);

            value = $input.val();
            $input.next().addClass('icon-container--bg-primary');
        }

        if (typeof navigator?.clipboard != 'undefined') {
            navigator.clipboard.writeText(value).then();
        }
    }

    destroyListener() {
        this.teardownListeners();
    }

    teardownListeners() {
        this.$element.off('click', $.proxy(this.onClick, this));
    }
}